import React, { useEffect } from 'react'
import UserlistStyles from "./UserList.module.css"
import { useState } from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
import NoteAltOutlinedIcon from '@mui/icons-material/NoteAltOutlined'
import InputBase from '@mui/material/InputBase';
import { styled, alpha } from '@mui/material/styles';
import SearchIcon from '@mui/icons-material/Search';
import FileCopyOutlinedIcon from '@mui/icons-material/FileCopyOutlined';
import PrintOutlinedIcon from '@mui/icons-material/PrintOutlined';
import Button from '@mui/material/Button'
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import FilterListIcon from '@mui/icons-material/FilterList';
import Modal from '@mui/material/Modal';
import { Link, Navigate } from 'react-router-dom';
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';

import { useSelector, useDispatch } from 'react-redux'
import { setNotifications } from '../../state/GlobalState'
import { setNotificationCount } from '../../state/GlobalState'
import { fetchNotifications } from '../../state/GlobalState'

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 480,
    bgcolor: 'background.paper',
    border: '2px solid gray',
    boxShadow: '2px 2px 10px 2px gray',
    borderRadius: '5px',
    p: 4,
};


const Search = styled('div')(({ theme }) => ({
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: alpha(theme.palette.common.white, 0.15),
    '&:hover': {
        backgroundColor: alpha(theme.palette.common.white, 0.25),
    },
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
        marginLeft: theme.spacing(1),
        width: 'auto',
    },
}));

const SearchIconWrapper = styled('div')(({ theme }) => ({
    padding: theme.spacing(0, 2),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
    color: 'inherit',
    '& .MuiInputBase-input': {
        padding: theme.spacing(1, 1, 1, 0),
        // vertical padding + font size from searchIcon
        paddingLeft: `calc(1em + ${theme.spacing(4)})`,
        transition: theme.transitions.create('width'),
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            width: '12ch',
            '&:focus': {
                width: '20ch',
            },
        },
    },
}));

// -----------------------------------------------------------------------


const UserList = () => {
    const name=useSelector((state)=>state.globalData.name);
    const count=useSelector((state)=>state.globalData.notificationCount);
    const dispatch =  useDispatch()
    const [tabName,setTabName]=useState("");
    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const navigate = useNavigate()

    const [filteredData,setFilteredData]=useState([])
    const [view, setView] = useState(false)
    const handleView = (row) => {
        setView(true)
        // console.log(row)
        setSelectedData(row)
        // navigate('/businessdetail')

    }

    const [entryCountTab,setEntryCountTab]=useState({
        total:0,
        vendor:0,
        corporate:0,
        user:0,
    })
    const handleViewClose = () => setView(false)

    const [query, setQuery] = useState("");
    const [rowCount, setRowCount] = useState(10);

    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(5);

    const [data, setData] = useState([])
    const [selectedData, setSelectedData] = useState({
     })

     const [entryCount,setEntryCount]=useState("");

    const getTicketData = async() => {

        
        try {
            const res = await axios.get(
                `${process.env.REACT_APP_STEELADMIN}/superAdmin/getAllUsers`,         
            ).then(async(res)=>{
                // console.log(res.data)
                const res2 = await axios.get(
                    `${process.env.REACT_APP_STEELADMIN}/corporate/getAllCorporateUsers`,         
                ).then(async(res2)=>{
                    // console.log(res2.data)
                    const updatedData=res.data.concat(res2.data)
                    const res3 = await axios.get(
                        `${process.env.REACT_APP_STEELADMIN}/vendor/getAllVendor`,         
                    ).then(async(res3)=>{
                        // console.log(res3.data)
                        const uu=updatedData.concat(res3.data);

                        const dd = uu.filter((yu) => {
                            return yu.approved && !yu.requested ? yu : false;
                          });
                        setData(dd)

                        // console.log(dd)
                        // console.log(res2.length)
                        // console.log(res.length)

                       


                    }
                    )
                }
                )
               
            })
            
            // console.log(res.data)
        } catch (error) {
            console.log(error)
        }
    }


    // useEffect(()=>{
    //     let count=0;
    //     data.forEach((tt)=>{
    //         if(tt.approved && !tt.requested)
    //         {
    //             count+=1;
    //         }
    //     })
    //     setEntryCount(count);
    // },[data])

    useEffect(() => {
       
        getTicketData()
    }, [])


    const handleTabChange=(tab)=>{

        setQuery(tab);

    }

    

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    // const getsubmitData = async () => {
    //     try {
    //         const submitData = await axios.post(
    //             `${process.env.REACT_APP_STEELADMIN}/superAdmin/register`,
    //             submitData,
    //             {
    //                 headers: {
    //                     "Content-Type": "application/json",
    //                 },
    //             }
    //         )
    //           // this is the snipte for the notification
    //        dispatch(fetchNotifications())

    //        dispatch(setNotificationCount({
    //         count:count+1,
    //        }))
    //         // console.log('Role Added.')
    //         getTicketData()
    //         // console.log(submitData)

    //     } catch (error) {
    //         console.error(error)

    //     }
    //     // else {
    //     //     if (submitData.branchAddressName === '') {
    //     //       alert('Please provide the address name.');
    //     //       return false;
    //     //     } else if (submitData.branchAddressDesc === '') {
    //     //       alert('Please provide the address description.');
    //     //       return false
    //     //     } else {
    //     //       alert('Please provide the contact number.');
    //     //       return false;
    //     //     }

    // }
    // useEffect(() => {
    //     getsubmitData()
    // }, [])


    const deleteUserId = async (id) => {
        try {
            const res = await axios.delete(
                `${process.env.REACT_APP_STEELADMIN}/superAdmin/deleteUser/${id}`
            )
            // dispatch(setNotificationCount({
            //     count:count+1,
            //    }))
              // this is the snipte for the notification
           dispatch(fetchNotifications())

           dispatch(setNotificationCount({
            count:count+1,
           }))
            // console.log(res.data)
            alert('Delete Successful!')
            getTicketData()

        } catch (error) {
            console.log(error)
        }
    }

    // useEffect(() => {
    //     getsubmitData()
    // }, [])

    useEffect(()=>{
       if(data!==null)

       {
           
           setFilteredData(data.filter(row => String(row?.roles?.name).includes(query)).reverse())
        }
    },[query,data])
  

    useEffect(()=>{
        setEntryCountTab((prev)=>{
            return{
                ...prev,
                total:data.length
            }
        })
        if(data!==null)
        {
           
        let userCount=0;
        let VendorCount=0;
        let corporateCount=0;
        data.forEach((tab)=>{

          
             
               
            if(tab?.roles?.name==="User")
            {
                userCount=userCount+1;
               
            }
            else if(tab?.roles?.name==="Vendor")
            {
                VendorCount+=1;
            }
            else
            {
                corporateCount+=1;
            }

           
           
               
           
        })
        setEntryCountTab((prev)=>{
            return{
                ...prev,
                vendor:VendorCount,
                corporate:corporateCount,
                user:userCount

            }
        })
    }
    },[data])

    useEffect(() => {
        setRowCount(filteredData.length)
        setPage(0);
    }, [data, query])

    return (
        <>
            <Card sx={{ maxWidth: '95%', border: 'none', outline: 'none', boxShadow: 'none', mt: '3%' }}>
                <CardContent>
                    <Paper className={UserlistStyles.myboder}>
                        <TableContainer sx={{ maxHeight: 650 }}>
                            <div className={UserlistStyles.ticketListBox1}>
                                <Box className={UserlistStyles.Box1}>
                                    <Typography variant='h5'>User</Typography>
                                    <Typography variant='h6'>{entryCount} users</Typography>

                                </Box>
                                <Box className={UserlistStyles.Box07}>
                                    {/* state={department} */}
                                    <Link to='/add user' className={UserlistStyles.BoxButtton} >
                                        <Button variant="contained" onClick={handleOpen} className={UserlistStyles.addUserBtn}>Add User</Button>
                                    </Link>
                                </Box>
                            </div>
                            <div className={UserlistStyles.ticketListBox2}>
                                <Box className={UserlistStyles.Box1}>
                                    <Search>
                                        <SearchIconWrapper>
                                            <SearchIcon sx={{ zIndex: '1' }} />
                                        </SearchIconWrapper>
                                        <StyledInputBase
                                            placeholder="Search…"
                                            onChange={(e) => setQuery(e.target.value)}
                                            inputProps={{ 'aria-label': 'search' }}
                                            sx={{ width: '100%', color: '##121926', backgroundColor: '#F8FAFC', borderRadius: '10px', border: '1px solid #Bdbdbd' }}
                                        />
                                    </Search>
                                </Box>
                            </div>

                            <div className={UserlistStyles.tabs}>
                                <ul>
                                    <li onClick={()=>handleTabChange("")} className={ query==="" && UserlistStyles.tabActive}>All Roles <span>{entryCountTab.total}</span> </li>
                                    <li onClick={()=>handleTabChange("Vendor")} className={ query==="Vendor" && UserlistStyles.tabActive} >Vendor <span>{entryCountTab.vendor}</span></li>
                                    <li onClick={()=>handleTabChange("Corporate")} className={ query==="Corporate" && UserlistStyles.tabActive}>Corporate <span>{entryCountTab.corporate}</span></li>
                                    <li onClick={()=>handleTabChange("User")} className={ query==="User" && UserlistStyles.tabActive}>User <span>{entryCountTab.user}</span></li>
                                </ul>

                            </div>
                            <Table stickyHeader aria-label="sticky table">
                                <TableHead>
                                    <TableRow className={UserlistStyles.Mainhead}>
                                        <TableCell className={UserlistStyles.Tablehead}>User</TableCell>
                                        <TableCell className={UserlistStyles.Tablehead}>Phone Number</TableCell>
                                        <TableCell className={UserlistStyles.Tablehead}>Registered</TableCell>
                                        <TableCell className={UserlistStyles.Tablehead}>Ip Address</TableCell>
                                        <TableCell className={UserlistStyles.Tablehead}>Role</TableCell>
                                        <TableCell className={UserlistStyles.Tablehead}>Action</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {/* {console.log(filteredData)} */}
                                    {filteredData
                                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                        .map((row) => {
                                           
                                            if(row.approved && row.roles.name!==null && !row.requested)
                                            {
                                                
                                                return (
                                                    <TableRow className={UserlistStyles.MainRow} hover role="checkbox" tabIndex={-1} key={row.id} >
                                                        <TableCell className={UserlistStyles.Tablerow}>{row?.name}<Box>{row?.email}</Box></TableCell>
                                                        <TableCell className={UserlistStyles.Tablerow}>{row?.phoneNumber}</TableCell>
                                                        <TableCell className={UserlistStyles.Tablerow}>{row?.dateCreated} </TableCell>
                                                        <TableCell className={UserlistStyles.Tablerow}>{row?.ipAddress} </TableCell>
                                                        <TableCell className={UserlistStyles.Tablerow}>{row?.roles?.name}</TableCell>
    
                                                        <TableCell className={UserlistStyles.Tablerow}>{row.action}
                                                        <Link variant="outlined" to={"/allusers"} state={{ data: row }}>
                                                            <VisibilityOutlinedIcon className={UserlistStyles.Tableicon}  />
                                                            </Link>
                                                            {/* <VisibilityOutlinedIcon className={UserlistStyles.Tableicon} onClick={() => handleView(row)} /> */}
    
                                                            <DeleteForeverOutlinedIcon className={UserlistStyles.Tableicon} style={{ marginLeft: '10%' }} onClick={() => deleteUserId(row.id)} />
                                                        </TableCell>
                                                    </TableRow>
                                                );
                                            }
                                            
                                        })

                                    }
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <TablePagination
                            rowsPerPageOptions={[5, 10, 15]}
                            component="div"
                            count={rowCount}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                            style={{ paddingTop: '2%' }}
                        />
                    </Paper>
                </CardContent>
            </Card>

            <Modal
                open={view}
                onClose={handleViewClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"

            >
                <Box sx={style} className={UserlistStyles.formStart}>
                    <form action='' method=''>
                        <label>User</label>
                        <Box className={UserlistStyles.form}>
                            <input text='text' value={selectedData?.name} disabled></input>
                        </Box>

                        <label>Email</label>
                        <Box className={UserlistStyles.form}>
                            <input text='text' value={selectedData?.email} disabled></input>
                        </Box>
                        <label>Phone Number</label>
                        <Box className={UserlistStyles.form}>
                            <input text='text' value={selectedData?.phoneNumber} disabled></input>
                        </Box>
                        <label>Registered</label>
                        <Box className={UserlistStyles.form}>
                            <input text='text' value={selectedData?.dateCreated} disabled></input>
                        </Box>
                        <label>Role</label>
                        <Box className={UserlistStyles.form}>
                            <input text='text' value={selectedData?.roles?.name} disabled></input>
                        </Box>
                    </form>
                </Box>
            </Modal>
        </>
    )
}

export default UserList





